
import React from 'react';




import IconButton from '@mui/material/IconButton';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';


import {
    CircularProgress,
    Typography
} from '@mui/material';




const FileSelector = ({
    filetype = 'all',
    onRowFileURLs,
    displayfileIndex,
    setdisplayfileIndex,
    fileFetchQuery
}) => {

    let fileCount = onRowFileURLs?.length;
    if (filetype !== 'all') {
        fileCount = onRowFileURLs?.filter(file => file.filetype === filetype);
    }

    const currFiletype = onRowFileURLs[displayfileIndex]?.filetype;


    return (
        (

            <div style={{ display: 'flex', flexDirection: 'row', gap: '0px' }}>

                {onRowFileURLs ? <>

                    <IconButton sx={{ transform: 'rotate(180deg)' }}
                        onClick={
                            () => {
                                // onRowFileURLs.filter(file => file.filetype === 'patientDoc')?.length + 1
                                setdisplayfileIndex(Math.max(0, (displayfileIndex - 1) % (fileCount)))
                            }}>
                        <ChevronRightIcon htmlColor='rgb(60, 165, 251)' fontSize='large' />
                    </IconButton>

                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '100%', width: '22px' }}>
                           {fileFetchQuery?.isFetching && <CircularProgress sx={{ color: 'var(--color-warning)' }} size={22} thickness={5} />}
                    </div>

                    <IconButton sx={{}}
                        onClick={
                            () => {

                                setdisplayfileIndex((displayfileIndex + 1) % (fileCount))
                            }}>
                        <ChevronRightIcon htmlColor='rgb(60, 165, 251)' fontSize='large' />
                    </IconButton>

                    <Typography sx={{ marginRight: '10px', color: 'var(--color-text)', pointerEvents: 'none',userSelect:'none' }}>
                        {`${displayfileIndex + 1} / ${onRowFileURLs?.length}`}
                    </Typography>

                    <Typography sx={{ color: 'rgb(33,194,27)', pointerEvents: 'none',userSelect:'none' }}>
                    {`${currFiletype === 'patientDoc' ? 'Document' :
                        currFiletype === 'invoice' ? 'Invoice':
                        currFiletype === 'proforma' ? 'Proforma' :
                        'Undetermined'
                        }`}
                    </Typography>

                </> : null}






            </div>)
    )



}



export default FileSelector;


